









































































































import Vue from 'vue';
import HCard from '@/ui/components/base/HCard.vue';
import HRating from '@/ui/components/base/HRating.vue';
import HDivider from '@/ui/components/base/HDivider.vue';
import ReviewActions from '@/ui/components/review/ReviewActions.vue';
import ReviewComment from '@/ui/components/review/ReviewComment.vue';
import ReviewCommentText from '@/ui/components/review/ReviewCommentText.vue';
import HAvatar from '@/ui/components/base/HAvatar.vue';

import useReviewVariables from '@/ui/composables/review/use-review-variables';
import useReviewFunctions from '@/ui/composables/review/use-review-functions';

import { iReview } from '../../../entities/review/review.types';

export default Vue.extend({
  name: 'Review',
  components: {
    HCard,
    HRating,
    HDivider,
    ReviewActions,
    ReviewComment,
    ReviewCommentText,
    HAvatar,
  },
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
  setup(props, { root }) {
    const reviewVariables = useReviewVariables(props.review as iReview);
    const reviewFunctions = useReviewFunctions(
      reviewVariables,
      props.review as iReview,
      root.$router,
    );
    return {
      ...reviewVariables,
      ...reviewFunctions,
    };
  },
});
